// 설정

const Layout = () => import('src/pages/Setting/Layout.vue')
const DocumentCodeManagement = () => import('src/pages/Setting/DocumentCodeManagement.vue')
const DocumentCodeForm = () => import('src/pages/Setting/DocumentCodeForm.vue')
const TemplateCategoryManagement = () => import('src/pages/Setting/TemplateCategoryManagement.vue')
const CategoryManagement = () => import('src/pages/Setting/CategoryManagement.vue')

const HospitalListPage = () => import('src/pages/Setting/Hospital/List.vue')
const HospitalNewForm = () => import('src/pages/Setting/Hospital/New.vue')
const HospitalEditForm = () => import('src/pages/Setting/Hospital/Edit.vue')

const OrganizationListPage = () => import('src/pages/Setting/Organization/List.vue')
const OrganizationNewForm = () => import('src/pages/Setting/Organization/New.vue')
const OrganizationEditForm = () => import('src/pages/Setting/Organization/Edit.vue')

export default {
  path: '/settings',
  name: 'Setting List',
  component: Layout,
  children: [
    {
      meta: {
        subheader: '카테고리 관리',
      },
      path: 'category',
      name: 'Category Management',
      component: CategoryManagement,
    },
    {
      meta: {
        subheader: '템플릿 카테고리 관리',
      },
      path: 'template-category',
      name: 'Template Category Management',
      component: TemplateCategoryManagement,
    },
    {
      meta: {
        subheader: '문서 코드 관리',
      },
      path: 'document-code',
      name: 'Document Code Management List',
      component: DocumentCodeManagement,
    },
    {
      meta: {
        subheader: '문서 코드 관리',
      },
      path: 'document-code/:templateID',
      name: 'Document Code Management Form',
      component: DocumentCodeForm,
      props (route) {
        return {
          templateID: route.params.templateID,
        }
      },
    },
    {
      meta: {
        subheader: '사업장 관리',
      },
      path: 'hospital',
      name: 'Hospital Management List',
      component: HospitalListPage,
    },
    {
      meta: {
        subheader: '사업장 등록',
      },
      path: 'hospital/new',
      name: 'Hospital Management New Form',
      component: HospitalNewForm,
    },
    {
      meta: {
        subheader: '사업장 수정',
      },
      path: 'hospital/:hospitalID',
      name: 'Hospital Management Edit Form',
      component: HospitalEditForm,
      props (route) {
        return {
          hospitalID: parseInt(route.params.hospitalID, 10),
        }
      },
    },

    {
      meta: {
        subheader: '조직/권한 관리',
      },
      path: 'organization',
      name: 'Organization Management List',
      component: OrganizationListPage,
    },
    {
      meta: {
        subheader: '사원 등록',
      },
      path: 'organization/new',
      name: 'Organization Management New Form',
      component: OrganizationNewForm,
    },
    {
      meta: {
        subheader: '사원 수정',
      },
      path: 'organization/:id',
      name: 'Organization Management Edit Form',
      component: OrganizationEditForm,
      props (route) {
        console.log(route.params.id)
        console.log(route.params.id)
        console.log(route.params.id)
        return {
          userID: parseInt(route.params.id, 10),
        }
      },
    },
  ],
}




// WEBPACK FOOTER //
// ./src/routes/setting.js